class MobileDock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const header = document.querySelector('.shopify-section-header');

    this.isAction = false;
    this.scrollY  = header ? parseInt(header.getBoundingClientRect().bottom) : 0;

    if (window.Shopify && window.Shopify.designMode) {
      this.scrollY = 0;
    }

    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    this.querySelectorAll('.dock__item:not([data-action])').forEach((item) => {
      item.addEventListener('click', () => this.setActiveItem(item));
    });
    document.addEventListener('menudrawer:close', this.hideStickyHeader.bind(this));
    document.addEventListener('searchmodal:close', this.hideStickyHeader.bind(this));

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();

    document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
    document.addEventListener('matchSmall', () => {
      document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
    });

    this.setInitialActiveItem();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >= this.scrollY) {
      this.classList.add('is-active');
    }
    else {
      this.classList.remove('is-active');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const delay = this.waitStickyHeader();
    this.setActiveItem(target);

    switch (target.dataset.action) {
      case 'cart':
        this.isAction = true;
        const cartLink = document.querySelector('#cart-icon-bubble');
        if (cartLink) {
          setTimeout(() => {
            cartLink.click();
          }, delay);
        }
        else {
          window.location.href = routes.cart_url;
        }
        break;

      case 'menu':
        this.isAction = true;

        const headerDrawerSummary = document.querySelector('header-drawer summary');
        if (headerDrawerSummary) {
          setTimeout(() => {
            headerDrawerSummary.click();
            setTimeout(() => headerDrawerSummary.blur(), 0);
          }, delay);
        }
        break;

      case 'search':
        this.isAction = true;

        const activeSearchInput = document.getElementById('Search-In-Header-Mobile') || document.getElementById('Search-In-Header') || document.getElementById('Search-In-Modal') || document.getElementById('Search-In-Modal-1');
        if (activeSearchInput) {
          setTimeout(() => {
            activeSearchInput.focus();
            if (typeof activeSearchInput.select === 'function') activeSearchInput.select();
          }, delay);
          break;
        }

        const searchToggle = document.querySelector('details-modal.header__search summary');
        if (searchToggle) {
          setTimeout(() => {
            searchToggle.click();
            const searchInput = document.getElementById('Search-In-Modal') || document.getElementById('Search-In-Modal-1');
            if (searchInput) searchInput.focus();
          }, delay);
          break;
        }

        window.location.href = routes.search_url;
        break;

      case 'account':
        this.isAction = true;

        const accountComponent = document.querySelector('shopify-account[menu="customer-account-main-menu"]');

        if (accountComponent) {
          setTimeout(() => {
            // Click the account component
            accountComponent.click();
            accountComponent.focus();

            // Click the internal button if available
            if (accountComponent.shadowRoot) {
              const shadowButton = accountComponent.shadowRoot.querySelector('button');
              if (shadowButton) {
                shadowButton.click();
                shadowButton.focus();
              }
            }

            // Dispatch click event
            const clickEvent = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            });
            accountComponent.dispatchEvent(clickEvent);

            // Blur after dialog closes to remove focus outline
            setTimeout(() => {
              accountComponent.blur();
              if (accountComponent.shadowRoot) {
                const shadowButton = accountComponent.shadowRoot.querySelector('button');
                if (shadowButton) {
                  shadowButton.blur();
                }
              }
            }, 100);
          }, delay);
        }
        break;
    }
  }

  setActiveItem(activeItem) {
    this.querySelectorAll('.dock__item').forEach((item) => item.classList.remove('is-active'));
    activeItem.classList.add('is-active');
  }

  setInitialActiveItem() {
    const currentPath = (window.location.pathname || '/').replace(/\/+$/, '') || '/';

    this.querySelectorAll('.dock__item').forEach((item) => {
      let isActive = false;
      const href = item.getAttribute('href');
      const accountUrl = item.getAttribute('data-account-url');

      if (href) {
        try {
          const linkPath = new URL(href, window.location.origin).pathname.replace(/\/+$/, '') || '/';
          isActive = linkPath === currentPath;
        } catch (e) {
          isActive = false;
        }
      }

      if (!isActive && accountUrl) {
        try {
          const accountPath = new URL(accountUrl, window.location.origin).pathname.replace(/\/+$/, '') || '/';
          isActive = accountPath === currentPath;
        } catch (e) {
          isActive = false;
        }
      }

      if (!isActive && item.dataset.action === 'search' && window.routes?.search_url) {
        const searchPath = (window.routes.search_url || '').replace(/\/+$/, '') || '/';
        isActive = searchPath === currentPath;
      }

      if (!isActive && item.dataset.action === 'cart' && window.routes?.cart_url) {
        const cartPath = (window.routes.cart_url || '').replace(/\/+$/, '') || '/';
        isActive = cartPath === currentPath;
      }

      if (isActive) item.classList.add('is-active');
    });
  }

  hideStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return;

    const isSticky = typeof header.sticky === 'function' ? header.sticky() : header.classList.contains('shopify-section-header-sticky');

    if (theme.config.mqlSmall && this.isAction && isSticky) {
      setTimeout(() => {
        header.hide();
        this.isAction = false;
      }, 500);
    }
  }

  waitStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return;

    const isSticky = typeof header.sticky === 'function' ? header.sticky() : header.classList.contains('shopify-section-header-sticky');

    if (!isSticky && !this.isElementVisible(header)) {
      if (typeof header.hide === 'function') {
        header.hide();
      }

      setTimeout(() => {
        if (typeof header.reveal === 'function') {
          header.reveal();
        }
      });

      return 250;
    }

    return 0;
  }

  isElementVisible(element) {
    const rect = element.getBoundingClientRect(),
        width  = window.innerWidth || document.documentElement.clientWidth,
        height = window.innerHeight || document.documentElement.clientHeight,
        efp    = function (x, y) { return document.elementFromPoint(x, y) };

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0 || rect.left > width || rect.top > height) {
      return false;
    }

    // Return true if any of its four corners are visible
    return (
      element.contains(efp(rect.left,  rect.top))
      || element.contains(efp(rect.right, rect.top))
      || element.contains(efp(rect.right, rect.bottom))
      || element.contains(efp(rect.left,  rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.top))
      || element.parentNode.contains(efp(rect.right, rect.top))
      || element.parentNode.contains(efp(rect.right, rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.bottom))
    );
  }
}
customElements.define('mobile-dock', MobileDock);
